/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState, useEffect} from 'react'
import SearchableSelect from '../../../../components/SearchableSelect/SearchableSelect'
import {Option} from '../../../../models/Sektor'
import {getTipPanelaDropdown} from '../../../../api/tipPanelaDropdown'

//  Props for the component
interface DropdownProps {
    value?: string | number
    initialValue?: string | number
    onChange?: (name: string, value: any) => void
    errors?: string | undefined
    touched?: boolean
    selectName?: string
}

const PanelTipDropdown: React.FC<DropdownProps> = ({
                                                       value,
                                                       initialValue,
                                                       onChange,
                                                       errors,
                                                       touched,
                                                       selectName,
                                                   }) => {
    const [tipPanelaDropdown, setTipPanelaDropdown] = useState<Array<Option>>([])
    const internalValue = initialValue ?? null

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await getTipPanelaDropdown()
                setTipPanelaDropdown(mapData(response.data))
            } catch (error) {
                console.error('Error fetching dropdown data:', error)
            }
        }
        fetchData()
    }, [])

    const finalValue = value ?? internalValue

    const mapData = (data) => {
        if (!data) {
            return []
        }
        return data.map((item) => ({label: item.naziv, value: item.id.toString()}))
    }

    return (
        <SearchableSelect
            options={tipPanelaDropdown}
            value={finalValue?.toString() ?? ''}
            onChange={onChange!}
            name={selectName ?? 'tipPanelaDropdown'}
            errors={errors}
            placeholder='Odaberi Tip Panela.'
            touched={touched}
        />
    )
}

export default PanelTipDropdown
